var primaryDeliveryOptions = {
    isSelectedPrimaryAddress: false
}
var primaryDeliveryMethod;
var CheckoutPrimaryAddressJs = (function ($) {
    var $radioButtons;
    var $clickElem;
    var showHidePrimaryDeliveryAddress = function (target, elemSel) {
        if (target.attr("value") === primaryDeliveryMethod) {
            $(".j-checkout-address-primary").show();

            const flagContainers = document.querySelectorAll('.iti__flag-container');
            const mobileQuery = window.matchMedia('(max-width: 767px)');

            if (flagContainers.length > 1 && mobileQuery.matches && navigator.userAgent.includes('Firefox')) {
                flagContainers[1].removeAttribute("style");

                setTimeout(function () {
                    flagContainers[1].style.left = 'auto';
                    flagContainers[1].style.top = '34px';
                }, 10);

            }
        } else {
            $(".j-checkout-address-primary").hide();
        }
    };

    var initShowHidePrimaryDel = function (radioButtonsSel, elemSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHidePrimaryDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'), ".j-checkout-address-primary");
        $(radioBSel).on("click", function () {
            showHidePrimaryDeliveryAddress($(this), elemSel);
        });
    };

    return {
        initShowHidePrimaryDel: initShowHidePrimaryDel,
        showHidePrimaryDeliveryAddress: showHidePrimaryDeliveryAddress
    }
})(jQuery);

$(document).ready(function () {

    if (typeof $("#primaryRadioButton") !== 'undefined' && typeof $("#primaryRadioButton").val() !== 'undefined') {
        if ( $("#sameRadioButton").length) {
            $("#sameRadioButton").prop('checked', true);
        }
        fillPrimaryAddressFieldsAjax()
        primaryDeliveryMethod = $("#primaryRadioButton").val();
        CheckoutPrimaryAddressJs.initShowHidePrimaryDel(".j-delivery-method-radio-buttons", ".j-checkout-address-primary");
    }

    $('input[type="radio"]').on('change', function() {
        if ($(this).val() === 'primary') {
            fillPrimaryAddressFieldsAjax()
        }
    });

    function fillPrimaryAddressFieldsAjax() {
        $.ajax({
            url: '/primary-delivery-address',
            method: 'GET',
            dataType: 'json',
            success: function(address) {
                if (address.firstName !== "") {
                    $('input[name="primaryAddress.firstName"]').val(address.firstName);
                    $('input[name="primaryAddress.lastName"]').val(address.lastName);
                    $('input[name="primaryAddress.streetname"]').val(address.line1);
                    $('input[name="primaryAddress.postalCode"]').val(address.postalCode);
                    $('input[name="primaryAddress.town"]').val(address.town);
                    $('input[name="primaryAddress.phone"]').val(address.phone);
                    $('input[name="primaryAddress.mobilePhone"]').val(address.mobilePhone);
                    $('input[name="primaryAddress.secondEmail"]').val(address.secondEmail);
                    if ( $("#primaryRadioButton").length) {
                        $("#primaryRadioButton").prop('checked', true);
                        $(".j-checkout-address-primary").show();
                    }
                }
            }
        });
    }
});